module.exports = __webpack_public_path__ + "img/card1.62a7ebd5.png";